const PASSWORD_STRENGTH_LEVELS = {
  0: { percent: 15, text: 'Very weak', color: '#ff4033' },
  1: { percent: 40, text: 'Weak', color: '#fe940d' },
  2: { percent: 60, text: 'Fear', color: '#f3ce00' },
  3: { percent: 80, text: 'Good', color: '#92d78b' },
  4: { percent: 100, text: 'Strong', color: '#4e9327' }
}
export { PASSWORD_STRENGTH_LEVELS }
export default PASSWORD_STRENGTH_LEVELS
